import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../components/Button';
import Container from '../components/Container';
import PageHeading from '../components/PageHeadings';
import Promo from '../components/Promo';

import { useOktaAuth } from '@okta/okta-react';
import { useDjAuth } from '../auth/DjAuthContext';
import { useUnifiedAuth } from '../auth/AuthContext';

import { useRecoilValue, useResetRecoilState } from 'recoil';
import { toast } from 'react-toastify';
import { authErrorAtom } from '../store/auth';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uri = searchParams.get('uri');
  const authError = useRecoilValue(authErrorAtom);
  const resetAuthError = useResetRecoilState(authErrorAtom);

  const { oktaAuth } = useOktaAuth();
  const { djAuth } = useDjAuth();
  const { unifiedAuthState } = useUnifiedAuth();

  const loginWithOkta = () => {
    if (uri) {
      oktaAuth.setOriginalUri(uri);
    }

    oktaAuth.signInWithRedirect();
  };

  const loginWithDJ = () => {
    djAuth.login();
  };

  useEffect(() => {
    if (unifiedAuthState?.isAuthenticated) {
      navigate(uri || '/');
    }
    if (authError) {
      toast.error(authError, { position: 'top-center' });
      resetAuthError();
    }
  }, [unifiedAuthState]);

  return (
    <Container fullHeight={true}>
      <div className="flex justify-between w-full flex-col items-center h-full">
        <div className="lg:w-1/3 justify-center mt-12">
          <div className="flex justify-center w-full mb-5">
            <PageHeading title="Welcome" white />
          </div>
          <div className="w-full flex justify-center">
            <div className="w-1/3">
              <Button text="Login" onClick={loginWithDJ} />
            </div>
          </div>
          <p className="text-white text-center mt-5">
            Trying to login as an MMC user?{' '}
            <a onClick={loginWithOkta} className="font-bold hover:no-underline cursor-pointer">
              Click here
            </a>
          </p>
          <p className="text-white text-center mt-5">
            Experiencing issues?{' '}
            <a href="mailto:fss@oliverwyman.com?subject=FSS - Account request" className="font-bold">
              Get in touch
            </a>
          </p>
        </div>

        <div className="mt-10 mb-6 w-full">
          <Promo />
        </div>
      </div>
    </Container>
  );
}
